import React, { Component } from 'react'
import { Form } from 'react-bootstrap';
import Validator from 'validatorjs';

import { FormControl } from '../../../../facturotopia';

class ClienteMinimalForm extends Component {

  state = {}

  constructor(props) {
    super(props);

    this.state = {
      validator: new Validator({}, this.rules)
    };
  }

  get rules() {
    return {
      nombre_comercial: ['required', 'string', 'min:2'],
      contacto: ['required', 'string', 'min:2'],
      telefono: ['required', 'string', 'min:8'],
      email: ['required', 'string', 'email'],
      password: ['required', 'string', 'min:8', 'password', 'confirmed'],
      password_confirmation: ['required', 'string', 'min:8', 'password'],
    }
  }

  validate(data) {
    const validator = new Validator(data, this.rules);

    validator.check();

    this.setState({
      validator
    });

    return validator;
  }

  handleOnChange = (value) => {
    const data = {
      ...this.props.data,
      ...value
    }

    const validator = this.validate(data);

    this.props.onFormDataChange({
      data,
      step: this.props.step,
      isValid: validator.passes()
    });
  }

  render() {
    const { data = {} } = this.props;
    const { validator } = this.state;

    return (
      <Form autoComplete="off">

        <FormControl type="text"
          label="Empresa"
          name="nombre_comercial"
          placeholder=""
          help="Nombre comercial"
          autoFocus={ true }
          validator={ validator }
          value={ data.nombre_comercial }
          onChange={ this.handleOnChange }
        />

        <FormControl type="text"
          label="Contacto"
          name="contacto"
          placeholder=""
          help=""
          validator={ validator }
          value={ data.contacto }
          onChange={ this.handleOnChange }
        />

        <FormControl type="text"
          label="Teléfono"
          name="telefono"
          placeholder=""
          help=""
          validator={ validator }
          value={ data.telefono }
          onChange={ this.handleOnChange }
        />

        <FormControl type="text"
          label="Email"
          name="email"
          placeholder="email@example.com"
          help=""
          validator={ validator }
          value={ data.email }
          onChange={ this.handleOnChange }
        />

        <FormControl type="password"
          label="Contraseña"
          name="password"
          placeholder="Usar contraseña segura"
          help=""
          validator={ validator }
          value={ data.password }
          onChange={ this.handleOnChange }
        />

        <FormControl type="password"
          label="Confirmar contraseña"
          name="password_confirmation"
          placeholder="Usar contraseña segura"
          help=""
          validator={ validator }
          value={ data.password_confirmation }
          onChange={ this.handleOnChange }
        />

      </Form>
    )
  }
}

export default ClienteMinimalForm;